import PaymentsStripeButtonModule from './payments-stripe-button.module'

export default PaymentsStripeButtonModule
